
<template>
    <div>
         <div class="card">
                            <header class="card-header">
                                <p class="card-header-title">{{ news.title }}</p>
                            </header>
                            <div class="card-image">
                                <figure class="media-left">
                                            <p class="image is-4by3">
                                                <img v-if="news.imgs.length>0" :src="getURLImgWithUUID(news.imgs[0].path_img)">
                                                <img v-else src="@/assets/128x128.png">
                                            </p>
                                </figure>
                                <!-- <figure class="image is-4by3" >
                                    <img :src="getImgUrl(news.id)" alt="Card image"   @click="viewNews(news.id)">
                                </figure> -->
                            </div>
                            <div class="card-content" >
                               {{  news.descptoin_txt ? `${news.descptoin_txt.substring(0, 200)}...` : `` }}
                            </div>
                            <footer class="card-footer">
                                <a href="#0" class="card-footer-item" @click="gotoLabNews(0)"><i class="fas fa-fw fa-search"></i> View</a>
                                <a href="#0" class="card-footer-item" @click="gotoLabNews(1)"  v-if="userRoleFind(5)"><i class="fas fa-fw fa-edit"></i> Edit</a>
                            </footer>
                        </div>
    </div>
</template> 

<script>

import getDateTimeFormatLocalizeFromISO from '../../mixins/methods/getDateTimeFormatLocalizeFromISO'
import userRoleFind from '../../mixins/methods/userRoleFind';
import {  mapMutations, mapState } from "vuex";
import {  getBaseURLLabNewsV2 , genUUID}  from '@/utils.js'



export default {
    name : "LabNewsElementCard",
    mixins:[getDateTimeFormatLocalizeFromISO,userRoleFind,],
    props:{
        news : Object,
    },
    computed:{
          ...mapState({
            labNewsElement : state => state.lab_news_element.labNewsElement ,
            user_role: state => state.master_data.user_role ,
          })
    },
    methods:{
        ...mapMutations({
             setLabNewsElement : 'lab_news_element/setLabNewsElement',
             setModeLabNewsElement: 'lab_news_element/setModeLabNewsElement',
        }),
        gotoLabNews(_mode){
            this.setLabNewsElement(this.news)
            this.setModeLabNewsElement(_mode)  // 0 == view ,1 == edit
            this.$router.push('/labnewsdetails')   
        },
        getURLImgWithUUID(url_img){
           return `${getBaseURLLabNewsV2()}${url_img}?${genUUID(12)}` 
           // return `${url_img}?${genUUID(12)}` 
        },
        
         
    }
}
</script>


<style scoped>

.image {
  max-width: 300px; 
  max-height: 300px;  
}

.image img {
  max-width: 100%;
  max-height: 100%;
  object-fit: scale-down;

 
}




</style>




                    